import { Component, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from '@core/services/translate/i18n.service';

@Component({
  template: ''
})
export class TranslateComponent {

  public get showI18nSpinner(): boolean {
    return !this.i18nService || this.i18nService.loading;
  }

  protected translate: TranslateService;
  public i18nService: I18nService;

  constructor(injector: Injector) {

    this.i18nService = injector.get(I18nService);
    this.translate = injector.get(TranslateService);

    this.i18nService.changeDependencies(injector);
    this.i18nService.load(injector);

  }
}
